import React from "react";
import { Flex, HelpIndicator, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { labelContainer, linkIcon, statusWithLinkWrapper } from "./styles_vanilla.css";

const StatusWithLink: React.FC<{
  label: string;
  urlToLaunch: string;
  hoverTooltip: string;
}> = ({ label, urlToLaunch, hoverTooltip }) => {
  return (
    <Flex className={statusWithLinkWrapper} flexDirection="row" alignItems="center" gap={8}>
      <Icon type="file-edit" data-testid="status-icon" />
      <div className={labelContainer}>
        <Text variant="strong-md">{label}</Text>
      </div>
      <HelpIndicator id="status-with-link-tooltip" placement="top" content={hoverTooltip}>
        <Icon
          type="external-link"
          className={linkIcon}
          color={Colors.Primary600}
          data-testid="status-with-link-icon"
          onClick={() => window.open(urlToLaunch, "_blank", "noopener,noreferrer")}
        />
      </HelpIndicator>
    </Flex>
  );
};

export default StatusWithLink;
